export const SRC_RECAPTCHA: string = 'https://www.google.com/recaptcha/api.js?onload=captchaLoadCallback';
